const appId = 'wx974e96b407539a07'
const WxHeaderUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='
const WxEndUrl = '&response_type=code&scope=snsapi_userinfo&#wechat_redirect'
const MeiQiaEntId = '083973d38d911813096c07c8facecd3f'
const MeiQiaToken = '9fdbe916387f00c5886403ce3d4b479a'
const MeiQiaLoader = 'https://static.meiqia.com/widget/loader.js'
export {
  WxEndUrl, // 微信授权路径拼接
  WxHeaderUrl, // 微信授权路径拼接
  MeiQiaLoader, // 美洽加载路径
  MeiQiaToken, // 美洽Token
  MeiQiaEntId, // 唤起美洽EntId
  appId // 拉取微信授权appId
}
